<template>
    <div class="ListResult">
        <!--
        <div v-show="version == 1">
            <div class="ListResult__chart">
                <overall-impact-graph :impact="results.overallImpact" v-tooltip.bottom="{ content:'Jako škála váhy - čím víc vpravo na škále, tím větší dopad, od zelené po červenou.' }"></overall-impact-graph>
                <div class="infoCircle">
                    <i class="fa fa-info-circle"
                       v-tooltip.bottom="{ content:'Jako škála váhy - čím víc vpravo na škále, tím větší dopad, od zelené po červenou.' }"
                    ></i>
                </div>
            </div>
        </div>
        -->
        <div>
            <div class="ListResult__chart"
                 v-tooltip.bottom="{ content:'Jako škála váhy - čím víc vpravo na škále, tím větší dopad, od zelené po červenou.' }"
            >
                <div style="font-weight: bold;">
                    <overall-impact-graph :impact="results.overallImpact"></overall-impact-graph>
                    <div class="ListResult__number" style="position: relative; top: -0.6em;left: 0.65em; font-size: 1.2em;">
                        {{ Math.round(results.overallImpact * 10 ) / 10}}
                        <i class="fa fa-info-circle infoCircleInline"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import _ from 'lodash';

    import OverallImpactGraph from '../charts/OverallImpactGraph.js';

    export default {

        'components': {
            OverallImpactGraph
        },

        data() {
            return {
                results: {},

                activeColors : [
                    '#95EED2',
                    '#00D3A9',
                    '#BDB29F',
                    '#FFAE71',
                    '#FF4F5C'
                ]
            }
        },

        'props': [
            'recipeId',
            'version'
        ],

        mounted() {
            if(this.recipeId) {
                this.loadResults(this.recipeId);
            }
        },

        computed: {
            rounded () {
                if (typeof(this.results.overallImpact) !== 'undefined') {
                    return Math.round(this.results.overallImpact);
                }

                return false;
            },

            letterValue () {
                let letters = [
                  'A', 'B', 'C', 'D', 'E'
                ];

                if (this.rounded) {
                    return letters[this.rounded -1];
                }
            }
        },

        methods: {
            loadResults(id) {
                let vm = this;

                axios.get('/api/result/' + id)
                    .then(function (response) {
                        vm.results = response.data;
                        console.log(vm.results);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    }
</script>

<style>
    .infoCircle {
        color: darkgrey;
        font-size: 1.2em;
        position: relative;
        top: -10px;
        display: inline-block;
    }

    .infoCircleInline {
        color: darkgrey;
        font-size: 0.8em;
        display: inline-block;
        margin-left: 0.5em;
        position: relative;
        top: -0.1em;
    }
</style>